import { Technique } from '@interfaces/technique.interface';

import api from './';

export const { useGetTechniquesQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getTechniques: build.query<Technique[], void>({
      query: () => ({ url: 'technique' }),
    }),
  }),
});
